import script from "./TogglePlat.vue?vue&type=script&lang=ts&setup=true"
export * from "./TogglePlat.vue?vue&type=script&lang=ts&setup=true"

import "./TogglePlat.vue?vue&type=style&index=0&id=10562b74&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10562b74"]])

export default __exports__